<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Validering fejlet</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content class="align-center">
  <div>
    <p class="orange med-text align-center">
      <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
      <br />
      <span>Ordren kunne ikke valideres</span>
      <br />
    </p>

    @if (isMultipleEftersyn) {
      <p>
        Serviceintervallet indeholder allerede et eftersyn - Godkendelse af denne ordre vil betyde 2 eftersyn i sammen interval
      </p>
    }

    <p>Hvad skal der ske med ordren?</p>
  </div>
  <div mat-dialog-actions class="align-center">
    <button mat-raised-button (click)="approve()" matTooltip="Ordren går igennem som normalt">Godkend ordren</button>
    <button mat-raised-button (click)="cancel()">Annuller ordren</button>
  </div>
</div>
